// require('bootstrap/js/src/tab.js');
const CustomEvent = require('custom-event');
const createComponentModule = require('../../common/utils/createComponentModule');

const EVENT_NAMESPACE = 'byl:tabs.';
const Event = {
  HIDE: `${EVENT_NAMESPACE}hide`,
  HIDDEN: `${EVENT_NAMESPACE}hidden`,
  SHOW: `${EVENT_NAMESPACE}show`,
  SHOWN: `${EVENT_NAMESPACE}shown`,
};

const dispatchEvent = (target, eventName) => {
  const event = new CustomEvent(eventName);
  target.dispatchEvent(event);
};

const getPanelIdFromTab = (tab) => {
  const index = tab.href.indexOf('#');
  return tab.href.substring(index + 1);
};

module.exports = createComponentModule('.tabs', (tabsComponent) => {
  // Based on https://inclusive-components.design/tabbed-interfaces/
  /* eslint-disable */

  if (tabsComponent.dataset.initialized === 'true') return;

  // Get relevant elements and collections
  const tablist = tabsComponent.querySelector('.tabs__tablist');
  const tabs = [...tablist.querySelectorAll('.tabs__tab')];
  const panels = [...tabsComponent.querySelectorAll('.tabs__tabpanel')];
  const panelsMap = panels.reduce((acc, panel) => {
    acc[panel.id] = panel;
    return acc;
  }, {});

  // If no tab has aria-selected, first tab is selected by default
  let selectedTab = tabs[0];

  // The tab switching function
  const switchTab = (oldTab, newTab) => {
    dispatchEvent(oldTab, Event.HIDE);
    dispatchEvent(newTab, Event.SHOW);
    newTab.focus();
    // Make the active tab focusable by the user (Tab key)
    newTab.removeAttribute('tabindex');
    // Set the selected state
    newTab.setAttribute('aria-selected', 'true');
    oldTab.removeAttribute('aria-selected');
    oldTab.setAttribute('tabindex', '-1');
    // Get the indices of the new and old tabs to find the correct
    // tab panels to show and hide
    const id = getPanelIdFromTab(newTab);
    const oldId = getPanelIdFromTab(oldTab);
    if (panelsMap[oldId]) panelsMap[oldId].hidden = true;
    if (panelsMap[id]) panelsMap[id].hidden = false;
    dispatchEvent(oldTab, Event.HIDDEN);
    dispatchEvent(newTab, Event.SHOWN);
  };

  // Add the tablist role to the first <ul> in the .tabsComponent container
  tablist.setAttribute('role', 'tablist');

  // Add semantics are remove user focusability for each tab
  Array.prototype.forEach.call(tabs, (tab, i) => {
    if (tab.getAttribute('aria-selected') === 'true') {
      selectedTab = tab;
    }

    tab.setAttribute('role', 'tab');
    tab.setAttribute('id', `tab${i + 1}`);
    tab.setAttribute('tabindex', '-1');
    tab.parentNode.setAttribute('role', 'presentation');

    // Handle clicking of tabs for mouse users
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const currentTab = tablist.querySelector('[aria-selected]');
      if (e.currentTarget !== currentTab) {
        switchTab(currentTab, e.currentTarget);
      }
    });

    // Handle keydown events for keyboard users
    tab.addEventListener('keydown', (e) => {
      // Get the index of the current tab in the tabs node list
      const index = Array.prototype.indexOf.call(tabs, e.currentTarget);
      // Work out which key the user is pressing and
      // Calculate the new tab's index where appropriate
      const dir = e.which === 37
        ? index - 1
        : e.which === 39
          ? index + 1
          : e.which === 40
            ? 'down'
            : null;
      if (dir !== null) {
        e.preventDefault();
        // If the down key is pressed, move focus to the open panel,
        // otherwise switch to the adjacent tab
        dir === 'down'
          ? panels[i].focus()
          : tabs[dir]
            ? switchTab(e.currentTarget, tabs[dir])
            : void 0;
      }
    });
  });

  // Add tab panel semantics and hide them all
  Array.prototype.forEach.call(panels, (panel, i) => {
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('tabindex', '-1');
    panel.setAttribute('aria-labelledby', tabs[i].id);
    panel.hidden = true;
  });

  // Initially activate the first tab and reveal the first tab panel
  selectedTab.removeAttribute('tabindex');
  selectedTab.setAttribute('aria-selected', 'true');
  const selectedPanel = panelsMap[getPanelIdFromTab(selectedTab)];
  if (selectedPanel) {
    selectedPanel.hidden = false;
  }
});
